@if (textsArray) {
  <div class="texts">
    <div class="row">
      <div class="caption">{{meta().info}}</div>
      <div class="array" [formArray]="textsArray">
        @for (text of texts; track i; let i = $index) {
          <app-text [formArray]="textsArray" [arrayIndex]="i" [model]="text" [meta]="metaText" (clear)="onDelete(i)" [readonly]="readonly()"></app-text>
        }
      </div>
      <button type="button" class="button" [disabled]="readonly()" (click)="onAdd()">
        <mat-icon>add_box</mat-icon>
      </button>
    </div>
  </div>
}
